import { IS_RTL_DIRECTION } from 'consts'
import { COLORS } from 'consts/colors'

import styled, { css } from 'styled-components'
import { flexCenterMixin, absoluteElementAlignCenterMixin } from 'styles/mixins'

const _getHorizontalPosition = () => {
  return IS_RTL_DIRECTION
    ? css`
        right: 8px;
      `
    : css`
        left: 8px;
      `
}

const _staticViewStyles = css`
  width: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  border-left: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.white};
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  z-index: 2; //for close icon  animation

  &:hover {
    background: ${COLORS.primaryLight};
  }
  &:active {
    path {
      fill: ${COLORS.secondaryDark};
    }
  }
`

const _absoluteViewStyles = css`
  position: absolute;
  ${absoluteElementAlignCenterMixin()}
  ${_getHorizontalPosition}
  ${flexCenterMixin()}
`

export const SearchIcon = styled.div<{
  $isStaticView: boolean
}>`
  ${({ $isStaticView }) =>
    $isStaticView ? _staticViewStyles : _absoluteViewStyles}
`
